<template>
    <b-modal size="lg" ref="createNewItemModal" hide-footer :title="$t('scdda_admin.edityear.header')">
        <b-container>
            <b-row>
                <b-col>
                    <b-form-group :label="$t('scdda_admin.edityear.year')" label-for="year">
                        <b-form-input id="year" type="text" :state="!$v.currentItem.year.$error ? null : false" v-model="currentItem.year" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <b-button class="button-margin mt-3" variant="primary" block @click="createItem">{{ $t("scdda_admin.edityear.save") }}</b-button>
    </b-modal>
</template>
    <script>
    import YearService from '../../../../../services/Riskmanagement/YearService';
    import { helpers, required } from 'vuelidate/lib/validators';
    export default {
        name: 'year-modal',
        props: ['savedCallback'],
        data() {
            return {
                currentItemEditMode: false,
                currentItem: {}
            }
        },
        validations: {
            currentItem: {
                year:               {required},
            }
        },
        methods: {
            enterEditMode() {
                this.currentItemEditMode = true;
            },
            leaveEditMode() {
                this.currentItemEditMode = false;
            },
            showModal() {
                this.$v.$reset();
                this.currentItemEditMode = false;
                this.$refs.createNewItemModal.show();
            },
            hideModal() {
                this.$refs.createNewItemModal.hide();
                this.currentItem = {};
                this.$v.$reset();
            },
            setItem(Item) {
                this.currentItem = Item;
            },
            createItem() {
                this.$v.$touch();

                if(this.$v.$error) {
                    return;
                }

                this.$store.commit('loading/setLoading', true);

                if(!this.currentItemEditMode) {
                    YearService.create(this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.edityear.success_title"),
                                type: 'success',
                                text: this.$t("scdda_admin.edityear.success_message")
                            });

                            this.$store.commit('loading/setLoading', false);

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.edityear.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }else {
                    YearService.update(this.currentItem.id, this.currentItem)
                        .then(response => {
                            this.$notify({
                                    group: 'global',
                                title: this.$t("scdda_admin.edityear.success_title"),
                                    type: 'success',
                                text: this.$t("scdda_admin.edityear.success_message")
                                });

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.edityear.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }
            }
        }
    }
    </script>
